import React from "react";

export default function BlueIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      fill="none"
      viewBox="0 0 6 5"
    >
      <path
        fill="#1C64F2"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.444"
        d="M1 1.567c0-.374 0-.56.073-.703a.667.667 0 01.291-.291C1.507.5 1.694.5 2.067.5h1.866c.374 0 .56 0 .703.073a.667.667 0 01.291.291c.073.143.073.33.073.703v1.866c0 .374 0 .56-.073.703a.667.667 0 01-.291.291c-.143.073-.33.073-.703.073H2.067c-.374 0-.56 0-.703-.073a.667.667 0 01-.291-.291C1 3.993 1 3.806 1 3.433V1.567z"
      ></path>
    </svg>
  );
}
